






import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconUser extends Vue {
    @Prop({ type: Number, default: 48 }) readonly size!: number
    @Prop({ type: String, default: 'currentColor' }) readonly color!: string
}
